export var DotsNavStyles = {
    height: 12,
    width: 12,
    borderRadius: '50%',
    border: 'none',
    marginInline: 6,
    cursor: 'pointer',
    marginTop: 24,
    padding: 0
};
export var ContainerStyles = {
    cursor: 'grab',
    marginTop: 8,
    overflow: 'unset',
    width: '80vw',
    marginBottom: 24
};
